<template>
  <div>
      <div class="title">
        {{title}}
      </div>
  </div>
</template>

<script>
export default {
props: {
  title: {
    type: String,
    default: '提示'
  }
}
}
</script>

<style lang='scss' scoped>
.title {
  margin-bottom: 20px;
  margin-left: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;

  &::before {
    content: '';
    display: inline-block;
    position: relative;
    top: 6px;
    left: -10px;
    width: 4px;
    height: 24px;
    border-radius: 3px;
    background-color: #009688;
  }
}
</style>